/**
*@Author zhoutong
*@Date 2022-11-08
*@Project WebStorm-admin-feature-cooperation-manage
*/
<template>
  <div class="MsgTable-container">
    <el-table
        v-loading="loading"
        :data="data"
        :header-cell-style="{background:'#F9F9F9'}"
        height="60vh"
        style="width: 100%">
      <el-table-column
          type="index"
          label="序号"
          width="50">
      </el-table-column>
      <el-table-column
          prop="title"
          show-overflow-tooltip
          label="标题">
        <template slot-scope="scope">
           <span style="cursor: pointer;color: #0d9869"
                 @click="open(scope.row.bLink)"
                 v-if="scope.row.bLink">【{{scope.row.secondCategory}}】{{scope.row.title}}</span>
          <span v-else >【{{scope.row.secondCategory}}】{{scope.row.title}}</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="beginTime"
          width="180"
          sortable
          label="到达时间">
      </el-table-column>
      <el-table-column
          width="180"
          v-if="isHandle"
          label="操作">
        <template slot-scope="scope">
          <span style="color: #0d9869;cursor: pointer" @click="setRead(scope.row)">标记已读</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {

  name: "MsgTable",

  props: {
    data:{
      type: Array,
      default: () => [],
    },
    loading:{
      type: Boolean,
      default: () => false,
    },
    isHandle:{
      type: Boolean,
      default: () => true,
    }
  },

  components: {},

  data() {
    return {}
  },

  watch: {},

  mounted() {
  },

  methods: {
    open(url){
      window.open(url)
    },
    setRead(row){
      this.$emit('setRead',row)
    }
  },

}
</script>

<style scoped lang="scss">
.MsgTable-container {
}
</style>